import { useHistory } from 'react-router-dom';

import { FullScreenLoader, isRetryableLinkErrorCode, LinkErrorScreen } from '@identity/presentation/components/base';
import { SIGN_IN_ROUTE } from '@identity/presentation/constants';
import { useConsumeMagicLink } from '@identity/presentation/hooks';

/**
 * The page the magic link opens. It has no UI of its own: it shows the loader, makes one call,
 * redirects and disappears. What it can render instead is one of the error screens.
 *
 * It declares no flow, and it is the only page of the domain that does not: the link it consumes may
 * belong to any of them, and which one is known only once the backend answers.
 */
export const MagicLinkLandingPage = () => {
  const history = useHistory();
  const { errorCode, retry } = useConsumeMagicLink();

  if (!errorCode) return <FullScreenLoader />;

  return (
    <LinkErrorScreen
      code={errorCode}
      onRetry={isRetryableLinkErrorCode(errorCode) ? retry : undefined}
      onSignIn={() => history.push(SIGN_IN_ROUTE)}
    />
  );
};
